import { jsx as _jsx } from "react/jsx-runtime";
import { GoogleAPIProvider } from "@jti/fe-clients";
import { getLoaderOptions } from "../../../../components/StoreLocator/store-locator.config";
import { useConfig } from "../../../../providers/useConfig";
import { useLocale } from "../../../../providers/useLocale";
export const StoreLocatorProviderWrapper = ({ children, componentLevelLanguage, }) => {
    const { locationServiceMapProvider, GOOGLE_MAPS_API, ISO_COUNTRY_CODE } = useConfig();
    const locale = useLocale();
    const effectiveLanguage = componentLevelLanguage?.trim() || locale;
    if (locationServiceMapProvider === "google") {
        return (_jsx(GoogleAPIProvider, { apiKey: GOOGLE_MAPS_API, options: getLoaderOptions(ISO_COUNTRY_CODE, effectiveLanguage), children: children }));
    }
    return children;
};
//# sourceMappingURL=StoreLocatorProviderWrapper.js.map